import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Vant from 'vant';
import 'vant/lib/index.css';
import './css/common.css';

import VueWechatTitle from 'vue-wechat-title'
import VConsole from 'vconsole';

if(process.env.NODE_ENV == "development") {
  new VConsole();
}

Vue.config.ignoredElements = ['wx-open-launch-weapp']
import {timeToDate} from '@/utils/date-format';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(Vant);
Vue.use(VueWechatTitle)

Vue.config.productionTip = false;

Vue.filter('timeToDate', timeToDate)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
